import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { getCulpritPropertyInsuranceOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPropertyInsurance/getCulpritPropertyInsuranceOptions';
import { getPropertyInsuranceOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPropertyInsurance/getPropertyInsuranceOptions';
import { PropertyInsuranceEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/PropertyInsurance.type';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const ShowInsuranceInformationWrapper = ({
  type,
}: {
  type: PropertyInsuranceEnum;
}) => {
  return <InsuranceInformation type={type} />;
};
const InsuranceInformation = ({ type }: { type: PropertyInsuranceEnum }) => {
  const { id, damagedId } = useParams();
  const { data } = useQuery(
    type === PropertyInsuranceEnum.damaged
      ? getPropertyInsuranceOptions({ id: +id!, damaged_id: +damagedId! })
      : getCulpritPropertyInsuranceOptions({ id: +id! }),
  );

  const showData =
    type === PropertyInsuranceEnum.damaged
      ? [
          { label: 'بیمه گر', value: data?.insurance?.name?.toString() || '' },
          {
            label: 'شماره بیمه',
            value: data?.insurance_number?.toString() || '',
          },
          {
            label: 'تاریخ شروع',
            value: data?.insurance_start_date?.toString() || '',
          },
          {
            label: 'تاریخ انقضا',
            value: data?.insurance_expiry_date?.toString() || '',
          },
          {
            label: 'تاریخ انقضا بیمه نامه سال قبل',
            value: data?.insurance_expiry_date_last_year?.toString() || '',
          },
        ]
      : [
          { label: 'بیمه گر', value: data?.insurance?.name?.toString() || '' },
          {
            label: 'شماره بیمه',
            value: data?.insurance_number?.toString() || '',
          },
          {
            label: 'تاریخ شروع',
            value: data?.insurance_start_date?.toString() || '',
          },
          {
            label: 'تاریخ انقضا',
            value: data?.insurance_expiry_date?.toString() || '',
          },
          {
            label: 'پرداخت از محل',
            value: data?.insurance_payment_by?.fa_const.toString() || '',
          },
          {
            label: 'شماره کوپن',
            value: data?.insurance_coupon_number?.toString() || '',
          },
          {
            label: 'تاریخ انقضا بیمه نامه سال قبل',
            value: data?.insurance_expiry_date_last_year?.toString() || '',
          },
          {
            label: 'سقف تعهدات مالی',
            value: data?.insurance_property_commitment_max
              ? `${data.insurance_property_commitment_max} ریال`
              : '',
          },
          {
            label: 'سقف تعهدات جانی',
            value: data?.insurance_injury_commitment_max
              ? `${data.insurance_injury_commitment_max} ریال`
              : '',
          },
          {
            label: 'سقف تعهدات سرنشین',
            value: data?.insurance_passenger_commitment_max
              ? `${data.insurance_passenger_commitment_max} ریال`
              : '',
          },
        ];
  return (
    <Box
      className={css({
        paddingTop: '24px',
        paddingBottom: '24px',
      })}
    >
      <ShowIncidentParticipantsDataCard
        data={showData}
        title="اطلاعات بیمه شخص ثالث"
      />
    </Box>
  );
};
export default ShowInsuranceInformationWrapper;
